import React from 'react';
import injectStores from '../RootStore/injectStores';
import { ScheduleGridHeaderCellProps } from './ScheduleGrid.Types';

const styles = {
  display: 'flex',
  alignItems: 'center',
  border: '1px solid #eee',
  padding: '0px',
  justifyContent: 'center',
  flexDirection: 'column',
};

export const LeftHeaderCell: React.FC<ScheduleGridHeaderCellProps> =
  injectStores((props: ScheduleGridHeaderCellProps) => {
    const {
      namespaceId = '',
      style,
      rowIndex,
      columnIndex,
      // routerStore,
      scheduleGridStore,
    } = props;
    // const count = 0;
    // const params = routerStore?.params;
    const currentStore = scheduleGridStore?.namespaces[namespaceId];
    const currentHeader =
      currentStore?.currentColumnHeaders?.[columnIndex] ?? null;
    if (currentHeader?.component) {
      const Component = currentHeader.component;
      return React.cloneElement(<Component />, {
        currentStore,
        currentHeader,
        styles,
        ...props,
      });
    }
    // console.log('LeftHeaderCell defaulting to title:', currentHeader?.title);
    return (
      <div
        key={`left-header-cell-${namespaceId}-${rowIndex}`}
        title={undefined}
        style={{
          ...style,
          ...styles,
          flexDirection: 'column',
          height: (typeof style?.height === 'number' ? style.height : 0) - 2,
          width: (typeof style?.width === 'number' ? style.width : 0) - 2,
        }}
      >
        {currentHeader && <b>{currentHeader.title}</b>}
      </div>
    );
  });

export default LeftHeaderCell;
